export default __webpack_public_path__ + "static/media/ico-ads-new.838a9a36.webp";